import React from "react";
import { TextField, Box } from "@mui/material";

function SalesAllocationNumInput({ allocationNumbers, handleChange }) {
  return (
    <Box m={0} width="100%" align="center">
      <h2 className="sectionTitle center">Allocation Numbers Input</h2>
      <Box m={1}>
        <TextField
          id="allocation_numbers"
          name="allocation_numbers"
          label="Allocation Number"
          type="text"
          size="small"
          variant="standard"
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{ style: { textAlign: "center" } }}
          helperText="Required Value"
          value={allocationNumbers}
          onChange={handleChange}
        />
      </Box>
    </Box>
  );
}

export default SalesAllocationNumInput;
